import * as React from 'react';

function Facebook(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.122 11.054a.5.5 0 01.5.497l.06 9.446 2.599-.017-.059-9.436a.502.502 0 01.497-.503l3.281-.02v-1.65l-3.286.019h-.003a.5.5 0 01-.5-.497l-.01-1.593c-.008-1.256.848-2.528 2.775-2.54l1-.006-.01-1.751-2.562.016c-.156-.012-3.076-.137-3.823 2.87-.014.048-.295.928-.241 3.013a.502.502 0 01-.497.513l-2.84.018.011 1.641 3.105-.02h.003zM10.184 22a.5.5 0 01-.499-.497l-.06-9.446-3.106.019h-.002a.499.499 0 01-.5-.497L6 8.939a.502.502 0 01.497-.503l2.836-.018c-.004-1.936.277-2.775.29-2.812.938-3.783 4.772-3.586 4.809-3.586L17.459 2h.003a.5.5 0 01.5.496l.018 2.751a.5.5 0 01-.497.503l-1.5.01c-1.321.008-1.786.797-1.782 1.533l.007 1.094 3.289-.019c.163.022.261.052.355.145a.5.5 0 01.148.355v2.65a.5.5 0 01-.497.5l-3.278.02.059 9.436a.502.502 0 01-.497.503l-3.6.023h-.003z"
        fill="currentColor"
      />
    </svg>
  );
}

export default Facebook;
